import React, { useEffect } from 'react';
import classNames from 'classnames';
import css from './style.scss';
import successIcon from 'assets/images/success-icon.svg'; 
import errorIcon from 'assets/images/error-icon.svg';     

const ToastMessage = ({ message, show, onClose, duration = 4000, type = 'info', action }) => {
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(timer);
  }, [show, duration, onClose]);

  if (!show) return null;

  // choose icon based on type
  const icon =
    type === 'success'
      ? successIcon
      : type === 'error'
      ? errorIcon
      : successIcon;

  return (
    <div className={classNames(css.toastContainer)}>
      <div
        className={classNames(css.toastBox, {
          [css.success]: type === 'success',
          [css.error]: type === 'error',
          [css.info]: type === 'info',
        })}
      >
        <img className={css.toastIcon} src={icon} alt={type} />
        <span>{message}</span>
        {action?.label && (
          <button
            type="button"
            className={css.toastAction}
            onClick={() => {
              action.onClick?.();
              onClose?.();
            }}
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default ToastMessage;
